module.exports = __webpack_public_path__ + "static/chipset-mediatek-a62d8a2ff83047b49759d9e65ec80ca2.svg";